import { render, staticRenderFns } from "./AdminScreen.vue?vue&type=template&id=56c95a68&scoped=true"
import script from "./AdminScreen.vue?vue&type=script&lang=js"
export * from "./AdminScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c95a68",
  null
  
)

export default component.exports